exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.main {\n  margin: 1ex;\n  padding: 1ex;\n  border: 2px solid #abc;\n}\n\ndiv.main>div {\n  margin: 0.8ex;\n}\n\ndiv.citation {\n  padding-left: 3em;\n  font-size: 90%;\n}\n\ndiv.abstract {\n  font-size: small;\n  font-style: italic;\n}\n\ndiv.main>button {\n  font-size: small;\n  float: left;\n  display: block;\n  margin-right: 30px;\n  border-radius: 25px;\n  outline: none;\n}\n\ndiv.title {\n  margin-top: 1ex;\n  border-top: 3px double silver;\n  padding: 1ex;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/db-record-topic-box/db-record-topic-box.component.css
// module id = 386
// module chunks = 0